import React, { useState, useContext } from 'react'
import { useEffect } from 'react'
import { EditorContext } from '../../../../../../components/CanvasEditor/Context/EditorProvider'
import TextEditor from './TextEditor'

const AddText = () => {

  const [text, setText] = useState('')
  const [editMode, setEditMode] = useState(false)
  const { editor, textEditorOptions, selectedObjects, resetField } = useContext(EditorContext)

  const addText = () => {
    editor.addText(text, textEditorOptions)
    setText('')
  }


  useEffect(()=>{
    if (selectedObjects.length > 0) {
      if (selectedObjects[0].type === 'text') {
        setEditMode(true)
        setText(selectedObjects[0].text)
        editor.updateText(selectedObjects[0].text, textEditorOptions)
      }
    }
    else{
      setEditMode(false)
    }

    // eslint-disable-next-line
  }, [textEditorOptions])

  useEffect(()=> {
    if (selectedObjects.length > 0) {
      setEditMode(true)
    }
    else{
      setEditMode(false)
      setText('')
      resetField()
    }
    // eslint-disable-next-line
  }, [selectedObjects])

  const handleChange = (e) => {
    if (editMode) {
      setText(e.target.value)
      editor.updateText(e.target.value, textEditorOptions)
    }
    else{
      setText(e.target.value)
    }
  }


  return (
    <div className='add-text'>
      <TextEditor />
      <div className='add-text-body'>
        <textarea value={text} onChange={handleChange}></textarea>
        {
          !editMode &&
          <button type="button" className='btn btn-sm btn-primary mt-2' onClick={addText}>Add Text</button>
        }
      </div>
      
    </div>
  )
}

export default AddText